import { MOUSETRAP_ACTIONS } from "@circle-react/components/constants";
import { useSpotlightSearch } from "@circle-react/components/Modals/SpotlightSearch";
import useMousetrap from "react-hook-mousetrap";

export const SearchWrapper = () => {
  const spotlightSearch = useSpotlightSearch();

  useMousetrap(MOUSETRAP_ACTIONS.OPEN_SEARCH_MODAL, e => {
    e.preventDefault();
    void spotlightSearch.show();
  });

  return null;
};
